import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "contact-info" }
const _hoisted_2 = { class: "first-item" }
const _hoisted_3 = {
  key: 0,
  class: "flex-row"
}
const _hoisted_4 = {
  key: 1,
  class: "flex-row"
}
const _hoisted_5 = { class: "other" }
const _hoisted_6 = {
  key: 0,
  class: "other"
}
const _hoisted_7 = {
  key: 1,
  class: "other"
}
const _hoisted_8 = {
  key: 2,
  class: "identification"
}
const _hoisted_9 = { class: "condition" }
const _hoisted_10 = { class: "view-exp" }
const _hoisted_11 = { class: "first-item" }
const _hoisted_12 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_area = _resolveComponent("van-area")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 1,
    isDisabled: _ctx.isDisabled,
    form: _ctx.form,
    prePathName: "id-card-info"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "title" }, "联系信息", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_cell_group, {
            title: "邮箱地址",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                name: "email",
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入邮箱地址",
                maxlength: "30",
                rules: [{ required: true, pattern: _ctx.pattern, message: '请输入正确的邮箱' }]
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          })
        ]),
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "tips" }, [
          _createElementVNode("i", { class: "iconfont icon-jingshigantanhao2" }),
          _createTextVNode(" 邮箱将用于发送交易结单、重要账户消息使用，请谨慎填写。 ")
        ], -1)),
        _createVNode(_component_van_cell_group, {
          title: "通讯地址",
          border: false
        }, {
          default: _withCtx(() => [
            (_ctx.openType !== 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (!_ctx.form.asFamilyAddress)
                    ? (_openBlock(), _createBlock(_component_van_field, {
                        key: 0,
                        name: "contactAddress",
                        modelValue: _ctx.form.contactAddressPre,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.contactAddressPre) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: "请选择省市区",
                        readonly: "",
                        "right-icon": "arrow-down",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAddressPicker = true)),
                        rules: [{ required: true, message: '请输入通讯地址' }]
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_van_field, {
                        key: 1,
                        name: "contactAddress",
                        modelValue: _ctx.form.contactAddress,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.contactAddress) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: "请选择省市区",
                        readonly: ""
                      }, null, 8, ["modelValue"])),
                  _createVNode(_component_van_checkbox, {
                    modelValue: _ctx.form.asFamilyAddress,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.asFamilyAddress) = $event)),
                    onChange: _ctx.changeToFamily
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "iconfont icon-xuanze1",
                        style: _normalizeStyle({ color: _ctx.form.asFamilyAddress ? '#A79A28' : '#A5B2DC' })
                      }, null, 4)
                    ]),
                    default: _withCtx(() => [
                      _cache[33] || (_cache[33] = _createTextVNode("同住宅地址"))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (!_ctx.form.addressChecked)
                    ? (_openBlock(), _createBlock(_component_van_field, {
                        key: 0,
                        name: "contactAddress",
                        modelValue: _ctx.form.contactAddressPre,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.contactAddressPre) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: "请选择省市区",
                        readonly: "",
                        "right-icon": "arrow-down",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAddressPicker = true)),
                        rules: [{ required: true, message: '请输入通讯地址' }]
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_van_field, {
                        key: 1,
                        name: "contactAddress",
                        modelValue: _ctx.form.contactAddress,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.contactAddress) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: "请选择省市区",
                        readonly: ""
                      }, null, 8, ["modelValue"])),
                  _createVNode(_component_van_checkbox, {
                    modelValue: _ctx.form.addressChecked,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.addressChecked) = $event)),
                    onChange: _ctx.changeAddress
                  }, {
                    icon: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "iconfont icon-xuanze1",
                        style: _normalizeStyle({ color: _ctx.form.addressChecked ? '#A79A28' : '#A5B2DC' })
                      }, null, 4)
                    ]),
                    default: _withCtx(() => [
                      _cache[34] || (_cache[34] = _createTextVNode("同证件地址"))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])),
            _createVNode(_component_van_popup, {
              show: _ctx.showAddressPicker,
              "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showAddressPicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_area, {
                  "area-list": _ctx.areaList,
                  onConfirm: _ctx.onConfirm,
                  onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showAddressPicker = false))
                }, null, 8, ["area-list", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.form.contactAddressPre === '其他')
            ? (_openBlock(), _createBlock(_component_van_field, {
                key: 0,
                name: "contactAddressOther",
                modelValue: _ctx.form.contactAddressOther,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.contactAddressOther) = $event)),
                modelModifiers: { trim: true },
                placeholder: "输入国家、地区",
                onBlur: _ctx.filterAddress,
                rules: [{ required: true, message: '请输入国家、地区' }]
              }, null, 8, ["modelValue", "onBlur"]))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.form.addressChecked && _ctx.openType === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_van_field, {
                name: "contactDetailAddress",
                modelValue: _ctx.form.contactDetailAddress,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.contactDetailAddress) = $event)),
                modelModifiers: { trim: true },
                maxlength: "150",
                placeholder: "请输入详细街道、楼层、门牌号",
                rules: [{ required: true, message: '请输入详细街道、楼层、门牌号' }]
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.form.asFamilyAddress && _ctx.openType !== 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_van_field, {
                name: "contactDetailAddress",
                modelValue: _ctx.form.contactDetailAddress,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.contactDetailAddress) = $event)),
                modelModifiers: { trim: true },
                maxlength: "150",
                placeholder: "请输入详细街道、楼层、门牌号",
                rules: [{ required: true, message: '请输入详细街道、楼层、门牌号' }]
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isProf)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "tips" }, "证明可为银行结单、水电费单等", -1)),
              _createVNode(_component_van_field, {
                name: "uploader",
                rules: [{ required: true, message: '请上传地址证明' }]
              }, {
                input: _withCtx(() => [
                  _createVNode(_component_van_uploader, {
                    modelValue: _ctx.fileList,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fileList) = $event)),
                    "before-read": _ctx.beforeRead,
                    accept: ".pdf,image/*",
                    "max-count": "1",
                    "preview-size": "86",
                    onClick: _ctx.uploadToApp,
                    readonly: _ctx.isApp,
                    deletable: false
                  }, {
                    "preview-cover": _withCtx(() => [
                      _createElementVNode("div", {
                        class: "preview-cover",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.fileDel()), ["stop"]))
                      }, _cache[35] || (_cache[35] = [
                        _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                      ]))
                    ]),
                    default: _withCtx(() => [
                      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "upload-style" }, [
                        _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }),
                        _createElementVNode("p", null, "住址证明")
                      ], -1))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "before-read", "onClick", "readonly"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", {
                    class: "sample",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.viewExp && _ctx.viewExp(...args)))
                  }, "查看正确示例")
                ]),
                _cache[37] || (_cache[37] = _createElementVNode("div", null, "证明需具备：", -1)),
                _cache[38] || (_cache[38] = _createElementVNode("p", null, "1.发出机构", -1)),
                _cache[39] || (_cache[39] = _createElementVNode("p", null, "2.个人姓名", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("p", null, "3.地址信息", -1)),
                _cache[41] || (_cache[41] = _createElementVNode("p", null, "4.发出日期在三个月以内", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_action_sheet, {
          show: _ctx.fileActionState,
          "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fileActionState) = $event)),
          actions: _ctx.actionsList,
          "cancel-text": "取消",
          "close-on-click-action": "",
          onSelect: _ctx.onFileSelect
        }, null, 8, ["show", "actions", "onSelect"]),
        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "title" }, "就业信息", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_cell_group, {
            title: "教育程度",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                name: "educationLevel",
                modelValue: _ctx.form.educationLevelText,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.educationLevelText) = $event)),
                readonly: "",
                placeholder: "请选择教育程度",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showEducationPicker = true)),
                rules: [{ required: true, message: '请选择教育程度' }],
                "right-icon": "arrow-down"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_popup, {
                show: _ctx.showEducationPicker,
                "onUpdate:show": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showEducationPicker) = $event)),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_picker, {
                    title: "请选择",
                    "default-index": _ctx.form.educationLevelIdx,
                    columns: _ctx.educationOptions,
                    onConfirm: _ctx.onEducationConfirm,
                    onCancel: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showEducationPicker = false))
                  }, null, 8, ["default-index", "columns", "onConfirm"])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_van_cell_group, {
          title: "就业状态",
          border: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_field, {
              name: "professionCode",
              modelValue: _ctx.form.professionCodeText,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.professionCodeText) = $event)),
              readonly: "",
              placeholder: "请选择就业状态",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showProfessionPicker = true)),
              rules: [{ required: true, message: '请选择就业状态' }],
              "right-icon": "arrow-down"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_popup, {
              show: _ctx.showProfessionPicker,
              "onUpdate:show": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showProfessionPicker) = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "请选择",
                  "default-index": _ctx.form.professionCodeIdx,
                  columns: _ctx.professionOptions,
                  onConfirm: _ctx.onProfessionConfirm,
                  onCancel: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showProfessionPicker = false))
                }, null, 8, ["default-index", "columns", "onConfirm"])
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }),
        (_ctx.form.professionCodeText === '其他')
          ? (_openBlock(), _createBlock(_component_van_field, {
              key: 3,
              class: "other",
              name: "otherProfessionCode",
              modelValue: _ctx.form.professionCodeOther,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.professionCodeOther) = $event)),
              placeholder: "请输入",
              rules: [{ required: true, message: '请输入' }]
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (![3,4,5,6].includes(_ctx.form.professionCode))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_van_cell_group, {
                title: "雇主名称",
                border: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    name: "companyName",
                    modelValue: _ctx.form.companyName,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.companyName) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: "请输入雇主名称",
                    maxlength: "150",
                    rules: [{ required: true, message: '请输入雇主名称' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_cell_group, {
                title: "职位名称",
                border: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    name: "jobPosition",
                    modelValue: _ctx.form.jobPosition,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.jobPosition) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: "请输入职位名称",
                    maxlength: "150",
                    rules: [{ required: true, message: '请输入职位名称' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_van_cell_group, {
                title: "业务性质",
                border: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    name: "jobPosition",
                    modelValue: _ctx.form.companyBusinessTypeText,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.companyBusinessTypeText) = $event)),
                    readonly: "",
                    placeholder: "请选择业务性质",
                    rules: [{ required: true, message: '请选择业务性质' }],
                    "right-icon": "arrow-down",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showBTPicker = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_popup, {
                    show: _ctx.showBTPicker,
                    "onUpdate:show": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.showBTPicker) = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_picker, {
                        title: "请选择",
                        "default-index": _ctx.form.companyBusinessTypeIdx,
                        columns: _ctx.businessTypeOptions,
                        onConfirm: _ctx.onBusinessTypeConfirm,
                        onCancel: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showBTPicker = false))
                      }, null, 8, ["default-index", "columns", "onConfirm"])
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "form"]))
}